export default __webpack_public_path__ + "static/media/arrow-right.6f0864f4.svg";